import React from 'react';
import LeftContent from './left-content';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart';
import cn from 'classnames';
export default function ResourceBox({ model }) {
    const classNames = {
        double: model.double,
        'coming-soon': model.comingSoon
    };
    return (React.createElement("div", { className: cn('resource-box', classNames) },
        React.createElement(ReferenceNumber, { referenceNumber: model.videoReferenceNumber }),
        React.createElement(Top, { model: model }),
        React.createElement(Bottom, { model: model })));
}
function Top({ model }) {
    const description = model.comingSoon
        ? `<p>${model.comingSoonText}</p>`
        : model.description;
    return (React.createElement("div", { className: "top" },
        model.isNew && React.createElement(NewLabel, null),
        model.k12 && (React.createElement("img", { className: "badge", src: "/dist/images/details/k-12-icon@3x.png", alt: "K12 resource" })),
        React.createElement("div", { className: "top-line" },
            React.createElement("h3", { className: model.k12 ? 'space-for-badge' : '' }, model.heading),
            model.creatorFest && (React.createElement("img", { title: "This resource was created by instructors at Creator Fest", src: "/dist/images/details/cf-badge.svg" }))),
        React.createElement(RawHTML, { className: "description", html: description })));
}
function ReferenceNumber({ referenceNumber }) {
    return (referenceNumber !== undefined && referenceNumber !== null && (React.createElement("div", { className: "reference-number" }, referenceNumber)));
}
function Bottom({ model }) {
    if (model.comingSoon && model.iconType === 'lock') {
        return null;
    }
    return (React.createElement("div", { className: "bottom" },
        React.createElement(LeftContent, { model: model }),
        model.printLink && (React.createElement("a", { className: "print-link", href: model.printLink },
            React.createElement(FontAwesomeIcon, { icon: faShoppingCart }),
            React.createElement("span", null, "Buy print")))));
}
function NewLabel() {
    return (React.createElement("div", { className: "new-label-container" },
        React.createElement("span", { className: "new-label" }, "NEW")));
}
